/**
 * 加载script
 *
 * @param {string} url url
 * @param {function} callback 回调事件
 * @param {Object} options script 特性
 *
 * @return {*}
 */
var loadScript = function (url, callback, options) {
    if (callback === void 0) { callback = function () { }; }
    if (options === void 0) { options = {}; }
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    Object.keys(options).map(function (item) {
        if (options[item]) {
            script[item] = options[item];
        }
    });
    if (script.readyState) {
        script.onreadystatechange = function () {
            if (script.readyState === 'loaded'
                || script.readyState === 'complete') {
                script.onreadystatechange = null;
                if (callback) {
                    callback();
                }
            }
        };
    }
    else {
        script.onload = function () {
            if (callback) {
                callback();
            }
        };
        script.onerror = function () {
            if (callback) {
                callback(new Error('load script err!'));
            }
        };
    }
    script.src = url;
    document.body.appendChild(script);
};

export { loadScript as l };
//# sourceMappingURL=loadScript-11f96412.js.map
